<template>
  <div v-if="bookmark">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <router-link
            class="title"
            :to="{name: 'BookmarkList'}"
          >
            Bookmarks
          </router-link>
        </div>
      </div>
    </section>

    <section class="container">
      <div class="columns">
        <div class="column">
          <div class="box">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th class="is-3">
                    Fields
                  </th>
                  <th>Values</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>url</th>
                  <td>{{ bookmark.url }}</td>
                </tr>
                <tr>
                  <th>title</th>
                  <td>{{ bookmark.title }}</td>
                </tr>
                <tr>
                  <th>description</th>
                  <td>{{ bookmark.description }}</td>
                </tr>
                <tr>
                  <th>favicon_url</th>
                  <td>{{ bookmark.faviconUrl }}</td>
                </tr>
                <tr>
                  <th>offline</th>
                  <td>{{ bookmark.offline }}</td>
                </tr>
                <tr>
                  <th>parsed</th>
                  <td>{{ bookmark.parsed }}</td>
                </tr>
                <tr>
                  <th>image_url</th>
                  <td>{{ bookmark.imageUrl }}</td>
                </tr>
                <tr>
                  <th>tag_list</th>
                  <td>{{ bookmark.tagList }}</td>
                </tr>
                <tr>
                  <th>Updated At</th>
                  <td>{{ bookmark.updatedAt }}</td>
                </tr>
                <tr>
                  <th>Created At</th>
                  <td>{{ bookmark.createdAt }}</td>
                </tr>
                <tr>
                  <th>Tags</th>
                  <td>
                    <div
                      v-for="tag in bookmarkTags"
                      :key="tag.id"
                    >
                      {{ tag.name }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <nav class="level is-mobile">
              <div class="level-left">
                <b-button
                  size="is-danger"
                  icon-left="trash"
                  class="level-item"
                  @click="confirmDelete(bookmark.id)"
                >
                  Delete
                </b-button>
              </div>
              <div class="level-right">
                <b-button
                  size="is-primary"
                  icon-left="edit"
                  @click="editRecord(bookmark.id)"
                >
                  Edit
                </b-button>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  // import _ from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  import { showMixin } from '@/mixins/crud/pagination'

  export default {
    name: 'Bookmark',
    mixins: [ showMixin('bookmark') ],
    props: [ 'id' ],
    computed: {
      ...mapGetters({
        byId: 'bookmarks/byId',
        tagsById: 'tags/byId'
      }),
      bookmark() {
        return this.byId(this.id)
      },
      bookmarkTags () {
        return this.bookmark.tags.map(tag => this.tagsById(tag))
      }
    },
    mounted() {
      let that = this
      this.loadById(this.id).then(function(response){
        if (!response) {
          that.$router.push({name: 'NotFound'})
        }
      })
    },
    methods: {
      ...mapActions({
        loadById: 'bookmarks/loadById',
        delete: 'bookmarks/delete',
      }),
      confirmDelete(id) {
        this.$buefy.dialog.confirm({
          title: 'Deleting Bookmark',
          message: 'Are you sure you want to <b>delete</b> this bookmark?',
          confirmText: 'Delete Account',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.deleteSelected(id)
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
